import { Box, Stack, Typography } from '@mui/material'
import { useContext, useEffect } from 'react'
import {
  AddressContext,
  AddressProviderValue,
} from 'pages/address/address.provider'
import { useCarrierList } from 'pages/address/address.hooks'
import AddressCarrierListItem from './address-carrier-list-item.component'

const AddressCarrierList = () => {
  const { selectedAssociationId, setSelectedAssociationId } = useContext(
    AddressContext
  ) as AddressProviderValue
  const { carriers, isLoading } = useCarrierList()

  useEffect(() => {
    if (!carriers.length) {
      setSelectedAssociationId(null)
      return
    }

    const isCurrentInList = carriers.some(
      (item) => item.carrier.associationId === selectedAssociationId
    )

    if (!isCurrentInList) {
      setSelectedAssociationId(carriers[0].carrier.associationId)
    }
  }, [carriers, selectedAssociationId, setSelectedAssociationId])

  if (isLoading) {
    return (
      <Box sx={{ px: 2, py: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Loading…
        </Typography>
      </Box>
    )
  }

  if (carriers.length === 0) {
    return (
      <Box sx={{ px: 2, py: 2 }}>
        <Typography variant="body2" color="text.secondary">
          No carriers found.
        </Typography>
      </Box>
    )
  }

  return (
    <Stack spacing={0}>
      {carriers.map((item) => (
        <AddressCarrierListItem
          key={item.carrier.associationId}
          item={item}
          isSelected={item.carrier.associationId === selectedAssociationId}
          onSelect={() =>
            setSelectedAssociationId(item.carrier.associationId)
          }
        />
      ))}
    </Stack>
  )
}

export default AddressCarrierList
